export default "__VITE_ASSET__ZBvhOYca__"